import {
  HexaV2NavItem,
  HexaV2NavUtilityItemsContainer,
} from '@/components/hexa-v2'
import { doLogout } from '@/proxy/auth/logout'
import { SIDEBAR_MENU as dict } from '@/resources/dict'
import { HexaIcons, SidebarMenuItems } from '@/resources/enums'
import { URLS } from '@/resources/enums/externalsUrls'
import { useQueryClient } from '@/proxy/react-query'

interface UtilityMenuItemsProps {
  navigate: (to: string) => void
  isMobile: boolean
}
const UtilityMenuItems = ({ isMobile, navigate }: UtilityMenuItemsProps) => {
  const queryClient = useQueryClient()

  return (
    <HexaV2NavUtilityItemsContainer>
      {isMobile && (
        <>
          <HexaV2NavItem
            key={SidebarMenuItems.MY_ACCOUNT}
            icon={HexaIcons.USER}
            label={dict.myAccount}
            onHxChangeActiveNavItem={() => navigate('/my-account')}
          />
          <HexaV2NavItem
            key={SidebarMenuItems.FAQ}
            icon={HexaIcons.HELP_CIRCLE}
            label={dict.faq}
            onHxChangeActiveNavItem={() => window.open(URLS.FAQ, '_blank')}
          />
        </>
      )}
      <HexaV2NavItem
        id={SidebarMenuItems.LOGOUT}
        icon={HexaIcons.LOGOUT}
        label={dict.logout}
        onHxChangeActiveNavItem={() => {
          void doLogout().then(() => {
            queryClient.clear()
          })
        }}
      />
    </HexaV2NavUtilityItemsContainer>
  )
}

export default UtilityMenuItems
